import logger from 'lib/utils/logger';

export function getVideoRecommendationsAuthToken(): string {
  const accessToken: string = process.env.OCELOT_VIDEO_RECOMMENDATIONS_AUTH_TOKEN || '';
  if (!accessToken) logger.catch('Missing env: OCELOT_VIDEO_RECOMMENDATIONS_AUTH_TOKEN');

  return accessToken;
}
